import styled from "styled-components";
import { fontMedium, fontNormal } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";
import { generateTransition, easeInOut } from "../../_static/Transitions";

export const RunnerOddsAtom = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
  text-align: center;
  font-size: 12px;
  line-height: 14px;
  opacity: ${(props) => props.scratched && 0.4};
  background-color: ${(props) => props.favorite && buildColor("yellow", "100")};
  will-change: background-color;
  transition: ${generateTransition(easeInOut, "background-color")};

  & > strong {
    margin-bottom: 2px;
  }
`;

export const Strong = styled.span`
  display: block;
  font-size: 14px;
  font-family: ${fontMedium};
  height: 16px;
  letter-spacing: 0;
  text-align: center;
  margin: 0 0 2px;
  color: ${buildColor("grey", "900")};
`;

export const Span = styled.span`
  display: block;
  font-size: 12px;
  font-family: ${fontNormal};
  font-weight: 500;
  height: 14px;
  letter-spacing: 0;
  text-align: center;
  color: ${buildColor("grey", "800")};
`;
